/*
Sohel 11/02/2022 2699761741 Added Event Tactic group
Sohel 11/03/2022 2699761741 Integrated code validation API
Sohel 11/14/2022 2699818958 Implemented run functionality
Ashraf 11/16/2022 2699818958 Error handling for event trigger save
Sohel 03/03/2023 2699823790 Added Event Trigger validate popup actions
Ravi 05/18/2023 2699823790 Added run buttton and integrated Api
Akhila 06/21/2023 2699823790 conditionally disable save and finish button on submission
*/
import {createSlice} from '@reduxjs/toolkit';
import {httpPost} from '../../../util/Rest';
import {httpGet} from './../../../util/Rest';
import {submissionEnd} from '../CommonActions/commonActions';
const initialState = {
  successMsg: null,
  errorMsg: null,
  isLoading: false,
  addEventTriggerGroupStatus: null,
  eventTriggerGroupData: {},
  allCode: [],
  runTriggerStatus: null,
  triggerGroupCode: '',
  validateTriggerGroupStatus: null,
  runEventTriggerStatus: null,
};

const addEventTriggerGroup = createSlice({
  name: 'addEventTriggerGroup',
  initialState,
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },

    fetchError: (state, action) => {
      state.errorMsg = action.payload;
      state.isLoading = false;
    },
    postEventTriggerGroupData: (state, action) => {
      state.addEventTriggerGroupStatus = action.payload?.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload?.response;
    },
    validateEventTriggerGroupData: (state, action) => {
      state.validateTriggerGroupStatus = action.payload?.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.triggerGroupCode = action.payload?.message;
    },
    getEventTriggerGroupData: (state, action) => {
      state.eventTriggerGroupData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
      state.addEventTriggerGroupStatus = action.payload.status;
      state.successMsg = action.payload.response;
    },
    getAllCode: (state, action) => {
      state.allCode = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    postRunTriggerData: (state, action) => {
      state.runTriggerStatus = action.payload?.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload?.response;
    },
    postRunEventTriggerData: (state, action) => {
      state.runEventTriggerStatus = action.payload?.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload?.response;
    },
    resetRunTriggerData: (state) => {
      state.errorMsg = null;
      state.successMsg = null;
      state.runTriggerStatus = null;
      state.isLoading = false;
    },
    resetRunEventTriggerData: (state) => {
      state.errorMsg = null;
      state.successMsg = null;
      state.runEventTriggerStatus = null;
      state.isLoading = false;
    },
    resetMsg: (state) => {
      state.successMsg = null;
      state.errorMsg = null;
      state.isLoading = false;
      state.addEventTriggerGroupStatus = null;
    },
    resetValidateEventTrigger: (state) => {
      state.validateTriggerGroupStatus = null;
      state.isLoading = false;
      state.errorMsg = null;
      state.triggerGroupCode = null;
    },
    resetData: (state) => {
      state.eventTriggerGroupData = {};
      state.successMsg = null;
      state.errorMsg = null;
      state.isLoading = false;
      state.triggerGroupCode = '';
    },
  },
});
export default addEventTriggerGroup.reducer;
const {
  fetchStart,
  fetchError,
  resetMsg,
  postEventTriggerGroupData,
  postRunTriggerData,
  resetRunTriggerData,
  getAllCode,
  getEventTriggerGroupData,
  resetData,
  validateEventTriggerGroupData,
  resetValidateEventTrigger,
  postRunEventTriggerData,
  resetRunEventTriggerData,
} = addEventTriggerGroup.actions;

export const postEventTriggerGroup = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`event/save/eventtriggergroup`, details)
      .then((data) => {
        dispatch(submissionEnd());
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(validateEventTriggerGroupData(data?.data));
        } else if (data && data.status && data.status === 200) {
          dispatch(postEventTriggerGroupData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const fetchEventTriggerGroup = (groupCode) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`event/find/eventtriggergroup/${groupCode}`)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(getEventTriggerGroupData(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const fetchAllCode = () => {
  return (dispatch) => {
    httpGet(`event/find/all/eventtriggercode`)
      .then((data) => {
        if (data?.status && data.status === 200) {
          dispatch(getAllCode(data?.response));
        } else {
          dispatch(fetchError(data?.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};
export const postRunTrigger = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`event/execute`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postRunTriggerData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const postRunEventTrigger = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`event/execute`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postRunEventTriggerData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const resetRunTrigger = () => {
  return (dispatch) => {
    dispatch(resetRunTriggerData());
  };
};
export const resetRunEventTrigger = () => {
  return (dispatch) => {
    dispatch(resetRunEventTriggerData());
  };
};
export const resetMessage = () => {
  return (dispatch) => {
    dispatch(resetMsg());
  };
};

export const resetTriggerGroupData = () => {
  return (dispatch) => {
    dispatch(resetData());
  };
};

export const resetValidateEventTriggerGroup = () => {
  return (dispatch) => {
    dispatch(resetValidateEventTrigger());
  };
};
